import { Observable } from 'rxjs';
import { MenuItemType } from '../enums/menu-item-type';
import { MenuItemCommand } from '../types/menu-item-command';
import { Params } from '@angular/router';
import { Guid, isNil, Nillable } from '@web/utils';
import { Icon } from '../../icon/enums/icon';
import { RouterLink, RouterLinkActiveOptions } from '@web/common';

export class MenuItem {
  public constructor(
    private readonly data: {
      id: Guid;
      label: string;
      type: MenuItemType;
      visibility$: Observable<boolean>;
      routerLinkActiveOptions: RouterLinkActiveOptions;
      icon?: Nillable<Icon>;
      routerLink?: Nillable<RouterLink>;
      link?: Nillable<string>;
      children?: Nillable<MenuItem[]>;
      command?: Nillable<MenuItemCommand>;
      queryParams?: Nillable<Params>;
      counter$?: Nillable<Observable<number>>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get label(): string {
    return this.data.label;
  }

  public get type(): MenuItemType {
    return this.data.type;
  }

  public get visibility$(): Observable<boolean> {
    return this.data.visibility$;
  }

  public get routerLinkActiveOptions(): RouterLinkActiveOptions {
    return this.data.routerLinkActiveOptions;
  }

  public get icon(): Nillable<Icon> {
    return this.data.icon;
  }

  public get routerLink(): Nillable<RouterLink> {
    return this.data.routerLink;
  }

  public get link(): Nillable<string> {
    return this.data.link;
  }

  public get children(): Nillable<MenuItem[]> {
    return this.data.children;
  }

  public get command(): Nillable<MenuItemCommand> {
    return this.data.command;
  }

  public get queryParams(): Nillable<Params> {
    return this.data.queryParams;
  }

  public get counter$(): Nillable<Observable<number>> {
    return this.data.counter$;
  }

  public isLink(): boolean {
    return this.type === MenuItemType.Link;
  }

  public isCommand(): boolean {
    return this.type === MenuItemType.Command;
  }

  public isMore(): boolean {
    return this.type === MenuItemType.More;
  }

  public isRouterLink(): boolean {
    return this.type === MenuItemType.RouterLink;
  }

  public hasIcon(): boolean {
    return !isNil(this.icon);
  }
}
